import { environment } from "../../../environments/environment";

export const API = {
  base: environment.apiUrl,

  features: {
    base: `${environment.apiUrl}/features`
  },

  auth: {
    base: `${environment.apiUrl}/auth`,
    me: `${environment.apiUrl}/auth/me`,
    public: `${environment.apiUrl}/auth/public`,
    logAcesso: `${environment.apiUrl}/auth/log-acesso`
  },

  logs: {
    base: `${environment.apiUrl}/logs`,
    operacoes: `${environment.apiUrl}/logs/operacoes`,
    operacoesExcel: `${environment.apiUrl}/logs/operacoes/excel`
  },

  vinculos: {
    base: `${environment.apiUrl}/vinculos`,
    empreendimentosDisponiveis: `${environment.apiUrl}/vinculos/empreendimentos-disponiveis`,
    empreendimentosDisponiveisPaginado: `${environment.apiUrl}/vinculos/empreendimentos-disponiveis-paginado`,
    empreendimentosPaginado: `${environment.apiUrl}/vinculos/empreendimentos-paginado`
  },

  dashboardTec: {
    base: `${environment.apiUrl}/DashboardTec`
  },

  dashboard: {
    base: `${environment.apiUrl}/Dashboard`,

    porAno: (ano: number) =>
      `${environment.apiUrl}/Dashboard?ano=${ano}`,

    porAnoEPeriodo: (
      ano: number,
      periodo: 'ano' | 'atual' | 'anterior'
    ) =>
      `${environment.apiUrl}/Dashboard?ano=${ano}&periodo=${periodo}`
  },

  operacoes: {
    extratosClientes: {
      base: `${environment.apiUrl}/operacoes/extratos-clientes`,
      preview: `${environment.apiUrl}/operacoes/extratos-clientes/preview`,
      previewIa: `${environment.apiUrl}/operacoes/extratos-clientes/preview-ia`,
      // Prévia com a carteira vinda da API do Sienge (vínculo do empreendimento).
      previewSienge: `${environment.apiUrl}/operacoes/extratos-clientes/preview-sienge`,
      confirmacao: `${environment.apiUrl}/operacoes/extratos-clientes/confirmacao`,
      previewLote: `${environment.apiUrl}/operacoes/extratos-clientes/preview-lote`,
      confirmacaoLote: `${environment.apiUrl}/operacoes/extratos-clientes/confirmacao-lote`,
      excel: `${environment.apiUrl}/operacoes/extratos-clientes/excel`,
      modeloPlanilha: `${environment.apiUrl}/operacoes/extratos-clientes/modelo-planilha`,
      arquivos: `${environment.apiUrl}/operacoes/extratos-clientes/arquivos`,

      arquivo: (id: number) =>
        `${environment.apiUrl}/operacoes/extratos-clientes/arquivos/${id}`,

      download: (id: number) =>
        `${environment.apiUrl}/operacoes/extratos-clientes/arquivos/${id}/download`,

      itens: (id: number) =>
        `${environment.apiUrl}/operacoes/extratos-clientes/arquivos/${id}/itens`,

      carteira: `${environment.apiUrl}/operacoes/extratos-clientes/carteira`,
      carteiraCompetencias: `${environment.apiUrl}/operacoes/extratos-clientes/carteira/competencias`,
      carteiraConsolidado: `${environment.apiUrl}/operacoes/extratos-clientes/carteira/consolidado`
    },

    extratosBancarios: {
      base: `${environment.apiUrl}/operacoes/extratos-bancarios`,
      preview: `${environment.apiUrl}/operacoes/extratos-bancarios/preview`,
      previewIa: `${environment.apiUrl}/operacoes/extratos-bancarios/preview-ia`,
      previewOpenFinance: `${environment.apiUrl}/operacoes/extratos-bancarios/preview-open-finance`,
      confirmacao: `${environment.apiUrl}/operacoes/extratos-bancarios/confirmacao`,
      excel: `${environment.apiUrl}/operacoes/extratos-bancarios/excel`,
      modeloPlanilha: `${environment.apiUrl}/operacoes/extratos-bancarios/modelo-planilha`,
      arquivos: `${environment.apiUrl}/operacoes/extratos-bancarios/arquivos`,

      arquivo: (id: number) =>
        `${environment.apiUrl}/operacoes/extratos-bancarios/arquivos/${id}`,

      download: (id: number) =>
        `${environment.apiUrl}/operacoes/extratos-bancarios/arquivos/${id}/download`,

      itens: (id: number) =>
        `${environment.apiUrl}/operacoes/extratos-bancarios/arquivos/${id}/itens`,

      itensPorCompetencia: `${environment.apiUrl}/operacoes/extratos-bancarios/itens-por-competencia`
    },

    // Aba "Contas Pagas" de Operações (substitui a antiga "Consolidado") -
    // upload -> preview -> confirmar -> persistido por empreendimento/mês/ano,
    // igual Extrato Cliente/Bancário. Rota própria, diferente de
    // operacoes.contasPagas (extrator stateless da tela Convert).
    contasPagasImportacao: {
      base: `${environment.apiUrl}/operacoes/contas-pagas-importacao`,
      preview: `${environment.apiUrl}/operacoes/contas-pagas-importacao/preview`,
      trocarFilial: `${environment.apiUrl}/operacoes/contas-pagas-importacao/trocar-filial`,
      confirmacao: `${environment.apiUrl}/operacoes/contas-pagas-importacao/confirmacao`,
      fluxoIncorrido: `${environment.apiUrl}/operacoes/contas-pagas-importacao/fluxo-incorrido`,
      classificarFluxoIncorrido: `${environment.apiUrl}/operacoes/contas-pagas-importacao/fluxo-incorrido/classificar`,
      splitFluxoIncorrido: `${environment.apiUrl}/operacoes/contas-pagas-importacao/fluxo-incorrido/split`,
      desfazerSplitFluxoIncorrido: (idOrigem: number) =>
        `${environment.apiUrl}/operacoes/contas-pagas-importacao/fluxo-incorrido/split/${idOrigem}/desfazer`,
      sugestoesFluxoIncorrido: `${environment.apiUrl}/operacoes/contas-pagas-importacao/fluxo-incorrido/sugestoes`,
      classificacoes: `${environment.apiUrl}/operacoes/contas-pagas-importacao/classificacoes`,
      diferencasExcel: `${environment.apiUrl}/operacoes/contas-pagas-importacao/diferencas/excel`,
      arquivos: `${environment.apiUrl}/operacoes/contas-pagas-importacao/arquivos`,

      arquivo: (id: number) =>
        `${environment.apiUrl}/operacoes/contas-pagas-importacao/arquivos/${id}`,

      download: (id: number) =>
        `${environment.apiUrl}/operacoes/contas-pagas-importacao/arquivos/${id}/download`
    },

    relatorios: {
      fluxoRealizado: `${environment.apiUrl}/operacoes/relatorios/fluxo-realizado`,
      fluxoRealizadoPdf: `${environment.apiUrl}/operacoes/relatorios/fluxo-realizado/pdf`
    },

    alertas: {
      listar: `${environment.apiUrl}/operacoes/alertas`,
      naoLidos: `${environment.apiUrl}/operacoes/alertas/nao-lidos`,
      marcarLido: (id: number) => `${environment.apiUrl}/operacoes/alertas/${id}/lido`
    },

    balancetes: {
      base: `${environment.apiUrl}/operacoes/balancetes`,
      extrair: `${environment.apiUrl}/operacoes/balancetes/extrair`,
      gerar: `${environment.apiUrl}/operacoes/balancetes/gerar`
    },

    contasPagas: {
      base: `${environment.apiUrl}/operacoes/contas-pagas`,
      extrair: `${environment.apiUrl}/operacoes/contas-pagas/extrair`,
      gerar: `${environment.apiUrl}/operacoes/contas-pagas/gerar`
    },
    
    conciliacao: {
      base: `${environment.apiUrl}/operacoes/conciliacao`,
      competenciasDisponiveis: `${environment.apiUrl}/operacoes/conciliacao/competencias-disponiveis`,
      importacoes: `${environment.apiUrl}/operacoes/conciliacao/importacoes`,
      executar: `${environment.apiUrl}/operacoes/conciliacao/executar`,
      confirmar: `${environment.apiUrl}/operacoes/conciliacao/confirmar`,
      salvarPrevia: `${environment.apiUrl}/operacoes/conciliacao/salvar-previa`,
      previa: `${environment.apiUrl}/operacoes/conciliacao/previa`,
      sugestoes: `${environment.apiUrl}/operacoes/conciliacao/sugestoes`,
      sugestoesSomaD1: `${environment.apiUrl}/operacoes/conciliacao/sugestoes-soma-d1`,
    },

    // Conciliação de DÉBITOS: saídas do extrato bancário x Contas Pagas.
    // Separada da de créditos - tabela, motor e prévia próprios.
    conciliacaoDebito: {
      importacoes: `${environment.apiUrl}/operacoes/conciliacao-debito/importacoes`,
      executar: `${environment.apiUrl}/operacoes/conciliacao-debito/executar`,
      previa: `${environment.apiUrl}/operacoes/conciliacao-debito/previa`,
      salvarPrevia: `${environment.apiUrl}/operacoes/conciliacao-debito/salvar-previa`,
      confirmar: `${environment.apiUrl}/operacoes/conciliacao-debito/confirmar`,
      contaPagaManual: `${environment.apiUrl}/operacoes/conciliacao-debito/conta-paga-manual`,
      excluirContaPagaManual: (id: number) =>
        `${environment.apiUrl}/operacoes/conciliacao-debito/conta-paga-manual/${id}`,
    },

    // Lançamentos que o analista inclui à mão no movimento do mês. Rota
    // própria porque é dado DECLARADO, e não importado.
    ajustes: {
      base: `${environment.apiUrl}/operacoes/ajustes`,
      excluir: (id: number) => `${environment.apiUrl}/operacoes/ajustes/${id}`,
    },
  },

  // Isolado do Contas Pagas do Convert (operacoes.contasPagas) - rotas e
  // regras próprias, ver EngenhariaContasPagasController no backend.
  engenharia: {
    contasPagas: {
      base: `${environment.apiUrl}/engenharia/contas-pagas`,
      extrair: `${environment.apiUrl}/engenharia/contas-pagas/extrair`,
      // Leitura pela IA, para os modelos de relatório que ainda não têm parser.
      extrairIa: `${environment.apiUrl}/engenharia/contas-pagas/extrair-ia`,
      gerar: `${environment.apiUrl}/engenharia/contas-pagas/gerar`
    },
    // Conciliador de Notas - ver EngenhariaConciliadorNotasController.
    conciliadorNotas: {
      base: `${environment.apiUrl}/engenharia/conciliador-notas`,
      consumo: `${environment.apiUrl}/engenharia/conciliador-notas/consumo`,
      // PDFs da pasta do SharePoint, lidos pelo servidor com a conta técnica.
      planilhaAbas: `${environment.apiUrl}/engenharia/conciliador-notas/planilha/abas`,
      planilhaPreview: `${environment.apiUrl}/engenharia/conciliador-notas/planilha/preview`,
      planilhaMapeamento: `${environment.apiUrl}/engenharia/conciliador-notas/planilha/mapeamento`,
      documentosLer: `${environment.apiUrl}/engenharia/conciliador-notas/documentos/ler`,
      documentosModo: `${environment.apiUrl}/engenharia/conciliador-notas/documentos/modo`,
      conferir: `${environment.apiUrl}/engenharia/conciliador-notas/conferir`,
      // Pasta grande: PDFs em lotes guardados no servidor e conferência em segundo plano.
      documentosEnviar: `${environment.apiUrl}/engenharia/conciliador-notas/documentos/enviar`,
      conferirIniciar: `${environment.apiUrl}/engenharia/conciliador-notas/conferir/iniciar`,
      conferirAndamento: (id: string) => `${environment.apiUrl}/engenharia/conciliador-notas/conferir/andamento/${id}`,
      recalcular: (id: number) =>
        `${environment.apiUrl}/engenharia/conciliador-notas/conferencias/${id}/recalcular`,
      ajuste: (id: number) =>
        `${environment.apiUrl}/engenharia/conciliador-notas/conferencias/${id}/ajuste`,
      excel: (id: number) =>
        `${environment.apiUrl}/engenharia/conciliador-notas/conferencias/${id}/excel`,
      empreendimentos: `${environment.apiUrl}/engenharia/conciliador-notas/empreendimentos`,
      historico: `${environment.apiUrl}/engenharia/conciliador-notas/conferencias`,
      arquivos: (id: number) =>
        `${environment.apiUrl}/engenharia/conciliador-notas/conferencias/${id}/arquivos`,
      arquivo: (id: number, idArquivo: number) =>
        `${environment.apiUrl}/engenharia/conciliador-notas/conferencias/${id}/arquivos/${idArquivo}`
    }
  },

  // Convert > Novas Conversões (parser criado pela IA) e Validação de Parsers.
  novasConversoes: {
    // Passo 1 (sem tipo): leitura completa do arquivo e o Excel geral.
    extracaoGeral: `${environment.apiUrl}/conversoes/novas/extracao-geral`,
    // Arquivo grande: inicia a leitura em segundo plano e acompanha o andamento.
    iniciarExtracaoGeral: `${environment.apiUrl}/conversoes/novas/extracao-geral/iniciar`,
    andamentoExtracaoGeral: (id: string) => `${environment.apiUrl}/conversoes/novas/extracao-geral/andamento/${id}`,
    // Tipo escolhido: colunas da lista ligadas aos campos do Convert do tipo (IA por layout).
    extracaoGeralDoTipo: (id: string, tipo: string) => `${environment.apiUrl}/conversoes/novas/extracao-geral/${id}/tipo/${tipo}`,
    excelGeral: `${environment.apiUrl}/conversoes/novas/extracao-geral/excel`,
    // De-Para: campos do Convert do tipo e a conversão com o mapa campo -> coluna.
    camposConvert: (tipo: string) => `${environment.apiUrl}/conversoes/novas/campos/${tipo}`,
    dePara: `${environment.apiUrl}/conversoes/novas/de-para`,
    deParaExcel: `${environment.apiUrl}/conversoes/novas/de-para/excel`,
    analisar: `${environment.apiUrl}/conversoes/novas/analisar`,
    iniciarAjusteDeRegra: `${environment.apiUrl}/conversoes/novas/ajuste-de-regra/iniciar`,
    excel: `${environment.apiUrl}/conversoes/novas/excel`,
    parsers: `${environment.apiUrl}/conversoes/novas/parsers`,
    parser: (id: number) => `${environment.apiUrl}/conversoes/novas/parsers/${id}`,
    arquivo: (id: number) => `${environment.apiUrl}/conversoes/novas/parsers/${id}/arquivo`,
    codigo: (id: number) => `${environment.apiUrl}/conversoes/novas/parsers/${id}/codigo`,
    testar: (id: number) => `${environment.apiUrl}/conversoes/novas/parsers/${id}/testar`,
    excelParser: (id: number) => `${environment.apiUrl}/conversoes/novas/parsers/${id}/excel`,
    validar: (id: number) => `${environment.apiUrl}/conversoes/novas/parsers/${id}/validar`,
    incorporado: (id: number) => `${environment.apiUrl}/conversoes/novas/parsers/${id}/incorporado`,
    desativar: (id: number) => `${environment.apiUrl}/conversoes/novas/parsers/${id}/desativar`,
    ajustar: (id: number) => `${environment.apiUrl}/conversoes/novas/parsers/${id}/ajustar`,
    ajustarComArquivo: (id: number) => `${environment.apiUrl}/conversoes/novas/parsers/${id}/ajustar-com-arquivo`,
    extrair: (id: number) => `${environment.apiUrl}/conversoes/novas/parsers/${id}/extrair`
  },

  // Importação > Importar BRM (histórico por empreendimento + mês/ano base).
  importacao: {
    brm: {
      base: `${environment.apiUrl}/importacao/brm`,
      empreendimentos: `${environment.apiUrl}/importacao/brm/empreendimentos`,
      historico: `${environment.apiUrl}/importacao/brm/historico`,
      item: (id: number) => `${environment.apiUrl}/importacao/brm/${id}`,
      download: (id: number) => `${environment.apiUrl}/importacao/brm/${id}/download`
    },
    // Importação > Importar Operação (planilha Acompanhamento de Projeto).
    operacao: {
      base: `${environment.apiUrl}/importacao/operacao`,
      empreendimentos: `${environment.apiUrl}/importacao/operacao/empreendimentos`,
      historico: `${environment.apiUrl}/importacao/operacao/historico`,
      item: (id: number) => `${environment.apiUrl}/importacao/operacao/${id}`,
      download: (id: number) => `${environment.apiUrl}/importacao/operacao/${id}/download`
    }
  },

  // Operações > Espelho de vendas (unidades por torre/andar e situação de venda).
  espelhoVendas: {
    empreendimentos: `${environment.apiUrl}/espelho-vendas/empreendimentos`,
    item: (idEmpreendimento: number) => `${environment.apiUrl}/espelho-vendas/${idEmpreendimento}`,
    historicoUnidade: (idEmpreendimento: number, idUnidade: number) =>
      `${environment.apiUrl}/espelho-vendas/${idEmpreendimento}/unidades/${idUnidade}/historico`
  },

  // API Externa: cadastro de usuários externos (token) e consumo da Web API.
  apiExterna: {
    usuarios: {
      base: `${environment.apiUrl}/api-externa/usuarios`,
      item: (id: number) => `${environment.apiUrl}/api-externa/usuarios/${id}`,
      token: (id: number) => `${environment.apiUrl}/api-externa/usuarios/${id}/token`,
      empreendimentos: `${environment.apiUrl}/api-externa/usuarios/empreendimentos`
    },
    consumo: {
      base: `${environment.apiUrl}/api-externa/consumo`,
      usuarios: `${environment.apiUrl}/api-externa/consumo/usuarios`
    },
    // Rota pública (token) - só para montar a documentação/exemplos na tela.
    publica: `${environment.apiUrl}/externo/v1/brm`
  },

  // VistoMob: vistoria/medição física de obra (o app mobile coleta; o Core
  // carrega a PMC, agenda as medições e cadastra os vistoriadores).
  vistomob: {
    empreendimentos: `${environment.apiUrl}/vistomob/empreendimentos`,
    cenarios: {
      base: `${environment.apiUrl}/vistomob/cenarios`,
      item: (id: number) => `${environment.apiUrl}/vistomob/cenarios/${id}`,
      vincular: (id: number) => `${environment.apiUrl}/vistomob/cenarios/${id}/vincular`,
      arquivo: (id: number) => `${environment.apiUrl}/vistomob/cenarios/${id}/arquivo`
    },
    medicoes: {
      base: `${environment.apiUrl}/vistomob/medicoes`,
      item: (id: number) => `${environment.apiUrl}/vistomob/medicoes/${id}`,
      liberarVistoria: (id: number) => `${environment.apiUrl}/vistomob/medicoes/${id}/liberar-vistoria`,
      finalizar: (id: number) => `${environment.apiUrl}/vistomob/medicoes/${id}/finalizar`,
      reabrir: (id: number) => `${environment.apiUrl}/vistomob/medicoes/${id}/reabrir`,
      fotos: (id: number) => `${environment.apiUrl}/vistomob/medicoes/${id}/fotos`
    },
    fotoConteudo: (idFoto: number) => `${environment.apiUrl}/vistomob/fotos/${idFoto}/conteudo`,
    checklistCampos: `${environment.apiUrl}/vistomob/checklist/campos`,
    usuarios: {
      base: `${environment.apiUrl}/vistomob/usuarios`,
      item: (id: number) => `${environment.apiUrl}/vistomob/usuarios/${id}`,
      convite: (id: number) => `${environment.apiUrl}/vistomob/usuarios/${id}/convite`,
      desbloquear: (id: number) => `${environment.apiUrl}/vistomob/usuarios/${id}/desbloquear`
    }
  },

  openFinance: {
    base: `${environment.apiUrl}/open-finance`,

    connectToken: `${environment.apiUrl}/open-finance/connect-token`,
    novaContaConectada: `${environment.apiUrl}/open-finance/nova-conta-conectada`,

    contasPorItem: (itemId: string) =>
      `${environment.apiUrl}/open-finance/itens/${itemId}/contas`,

    status: (idEmpreendimentoFinanceiro: number) =>
      `${environment.apiUrl}/open-finance/${idEmpreendimentoFinanceiro}/status`,

    // Conta já cadastrada sem Open Finance sendo conectada depois.
    conectarContaExistente: (idEmpreendimentoFinanceiro: number) =>
      `${environment.apiUrl}/open-finance/${idEmpreendimentoFinanceiro}/conectar`,

    contasPorEmpreendimento: (idEmpreendimento: number) =>
      `${environment.apiUrl}/open-finance/empreendimento/${idEmpreendimento}/contas`
  },

  empreendimentos: {
    base: `${environment.apiUrl}/Empreendimento`,
    paginado: `${environment.apiUrl}/Empreendimento/paginado`,

    cronograma: {
      base: `${environment.apiUrl}/Empreendimento/cronograma`,

      porEmpreendimento: (idEmpreendimento: number) =>
        `${environment.apiUrl}/Empreendimento/${idEmpreendimento}/cronograma`,

      atualizar: (idEmpreendimentoCronograma: number) =>
        `${environment.apiUrl}/Empreendimento/cronograma/${idEmpreendimentoCronograma}`
    },

    financeiro: {
      porEmpreendimento: (idEmpreendimento: number) =>
        `${environment.apiUrl}/Empreendimento/${idEmpreendimento}/financeiro`,

      atualizar: (idEmpreendimentoFinanceiro: number) =>
        `${environment.apiUrl}/Empreendimento/financeiro/${idEmpreendimentoFinanceiro}`,

      excluir: (idEmpreendimentoFinanceiro: number) =>
        `${environment.apiUrl}/Empreendimento/financeiro/${idEmpreendimentoFinanceiro}`
    }
  },

  incorporador: {
    base: `${environment.apiUrl}/Incorporador`
  },

  investidores: {
    base: `${environment.apiUrl}/Investidores`
  },

  // Tipos de investidor do banco (combo "Tipo" do modal de investidor).
  tiposInvestidor: {
    base: `${environment.apiUrl}/TipoInvestidor`
  },

  usuarios: {
    base: `${environment.apiUrl}/Usuario`
  },

  spe: {
    base: `${environment.apiUrl}/Spe`,

    porIncorporador: (idIncorporador: number) =>
      `${environment.apiUrl}/Spe/incorporador/${idIncorporador}`
  },

  securitizadora: {
    base: `${environment.apiUrl}/Securitizadora`
  },

  // Cadastros > Empresa: junta Investidor e Incorporador (papéis).
  empresa: {
    base: `${environment.apiUrl}/Empresa`,
    // Combo SPE Incorporadora do empreendimento: empresas marcadas como SPE.
    spes: `${environment.apiUrl}/Empresa/spes`,
    papel: (id: number, papel: string) => `${environment.apiUrl}/Empresa/${id}/papel/${papel}`
  },

  // Cadastros > Contas: contas bancárias com ou sem empreendimento.
  contaBancaria: {
    base: `${environment.apiUrl}/ContaBancaria`,
    vinculo: (id: number, idEmpreendimento: number) =>
      `${environment.apiUrl}/ContaBancaria/${id}/empreendimento/${idEmpreendimento}`,
    desvincular: (id: number) => `${environment.apiUrl}/ContaBancaria/${id}/empreendimento`
  },

  // Cadastro de Operações e o vínculo delas com os empreendimentos.
  // Configurações > Escopos (lista da aba Escopo do empreendimento).
  escopos: {
    base: `${environment.apiUrl}/Escopo`
  },
  cadastroOperacao: {
    base: `${environment.apiUrl}/CadastroOperacao`,
    porEmpreendimento: (idEmpreendimento: number) =>
      `${environment.apiUrl}/CadastroOperacao/empreendimento/${idEmpreendimento}`,
    vinculo: (id: number, idEmpreendimento: number) =>
      `${environment.apiUrl}/CadastroOperacao/${id}/empreendimento/${idEmpreendimento}`
  },

  perfil: {
    base: `${environment.apiUrl}/Perfil`
  },

  permissaoTela: {
    base: `${environment.apiUrl}/PermissaoTela`
  },

  perfilPermissaoTela: {
    base: `${environment.apiUrl}/perfil-permissao-tela`
  },

  obraCompetencia: {
    base: `${environment.apiUrl}/obra-competencia`
  },

  auditorContrato: {
    base: `${environment.apiUrl}/auditor-contrato`,
    analisar: `${environment.apiUrl}/auditor-contrato/analisar`,
    exportar: `${environment.apiUrl}/auditor-contrato/exportar`
  },

  auditorOperacoesFinanceiras: {
    base: `${environment.apiUrl}/auditor-operacoes-financeiras`,
    temas: `${environment.apiUrl}/auditor-operacoes-financeiras/temas`,
    analisar: `${environment.apiUrl}/auditor-operacoes-financeiras/analisar`,
    exportar: `${environment.apiUrl}/auditor-operacoes-financeiras/exportar`
  },

  extratosBancariosNaoIdentificados: {
    base: `${environment.apiUrl}/extratos-bancarios-nao-identificados`,

    download: (id: number) =>
      `${environment.apiUrl}/extratos-bancarios-nao-identificados/${id}/download`,

    mapeado: (id: number) =>
      `${environment.apiUrl}/extratos-bancarios-nao-identificados/${id}/mapeado`
  },
    feriados: {
    base: `${environment.apiUrl}/Feriado`,
    // Só as datas dos feriados ativos, para o cálculo de dia útil.
    datas: `${environment.apiUrl}/Feriado/datas`,

    porId: (id: number) =>
      `${environment.apiUrl}/Feriado/${id}`
  },

  classificacoesContasPagas: {
    base: `${environment.apiUrl}/ClassificacaoContaPaga`,

    porId: (id: number) =>
      `${environment.apiUrl}/ClassificacaoContaPaga/${id}`
  },

  credenciaisOperador: {
    base: `${environment.apiUrl}/credenciais-operador`,

    porId: (id: number) =>
      `${environment.apiUrl}/credenciais-operador/${id}`
  },

  // Integração Sienge: conexões por cliente (tenant) e vínculo de cada
  // empreendimento com o empreendimento no Sienge.
  integracoesSienge: {
    base: `${environment.apiUrl}/integracoes-sienge`,

    porId: (id: number) =>
      `${environment.apiUrl}/integracoes-sienge/${id}`,

    testar: (id: number) =>
      `${environment.apiUrl}/integracoes-sienge/${id}/testar`,

    empreendimentosSienge: (id: number) =>
      `${environment.apiUrl}/integracoes-sienge/${id}/empreendimentos`,

    vinculo: (idEmpreendimento: number) =>
      `${environment.apiUrl}/integracoes-sienge/vinculos/${idEmpreendimento}`
  },

  // Controle de sessao concorrente por empreendimento (Operacoes). Impede
  // que dois usuarios trabalhem no mesmo empreendimento ao mesmo tempo.
  operacoesSessao: {
    base: `${environment.apiUrl}/operacoes/sessao`,

    iniciar: (idEmpreendimento: number) =>
      `${environment.apiUrl}/operacoes/sessao/${idEmpreendimento}`,

    heartbeat: (identificadorSessao: string) =>
      `${environment.apiUrl}/operacoes/sessao/${identificadorSessao}/heartbeat`,

    encerrar: (identificadorSessao: string) =>
      `${environment.apiUrl}/operacoes/sessao/${identificadorSessao}`,

    encerrarBeacon: (identificadorSessao: string) =>
      `${environment.apiUrl}/operacoes/sessao/${identificadorSessao}/encerrar-beacon`,

    encerrarTodas: `${environment.apiUrl}/operacoes/sessao/encerrar-todas`,
    ativas: `${environment.apiUrl}/operacoes/sessao/ativas`,

    // Versao detalhada da listagem — usada pela tela administrativa
    // "Sessoes de operacao" em Gerenciar Acessos.
    ativasDetalhado: `${environment.apiUrl}/operacoes/sessao/ativas/detalhado`,

    // Liberacao FORCADA por administrador (kick de outro usuario).
    forcar: (identificadorSessao: string) =>
      `${environment.apiUrl}/operacoes/sessao/${identificadorSessao}/forcar`
  },
};

export const APP = {
  base: environment.appUrl,
  login: `${environment.appUrl}/login`,
  callback: `${environment.appUrl}/callback`,
  dashboard: `${environment.appUrl}/dashboard`,
};